export const UNIVERS_GET_REQUEST = "UNIVERS_GET_REQUESTED";
export const UNIVERS_GET_SUCCESS = "UNIVERS_GET_SUCCESS";
export const UNIVERS_GET_ERROR = "UNIVERS_GET_ERROR";
